export var pillValue = function (prefix, labelKey) {
    if (labelKey === void 0) { labelKey = 'label'; }
    return function (option) { return (option ? "".concat(prefix, ": ").concat(option[labelKey]) : "".concat(prefix, ": All")); };
};
